﻿import BaseView from '../base-view';

export default BaseView.extend({
	initialize: function() {
		// references to elements
		this.dateFull = this.query('.js-date-time-full');

		// only create a picker if there is one
		if (this.dateFull) {
			// create picker
			this.$picker = this.initDatePicker();
			this.$picker.on('set', this.setTime.bind(this));
		}
	},

	/**
	 * create and return a datepicker
	 **/
	initDatePicker: function() {
		return $('.js-date').pickadate({
			format: 'dd.mm.yyyy',
			max: true
		}).pickadate('picker');
	},

	/**
	 * Set time handler
	 * get current date and fill hidden field
	 **/
	setTime: function(e) {
		if (!e.select) {
			return false;
		}

		var date = new Date(e.select),
			year = date.getFullYear(),
			month = date.getMonth() + 1,
			day = date.getDate();

		this.dateFull.value = year + '-' + month + '-' + day;
	}
});
